var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L8 11.7778L8 18",
    stroke: "#888281",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11L13 11.7778L13 18",
    stroke: "#888281",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8L16.9284 20.9687C16.9284 21.5075 16.7026 22.0241 16.3008 22.4051C15.8989 22.786 15.3539 23 14.7856 23H6.21412C5.6458 23 5.10076 22.786 4.6989 22.4051C4.29703 22.0241 4.07127 21.5075 4.07127 20.9687L3 8H18Z",
    stroke: "#888281",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2V4C6 4.55228 6.44772 5 7 5H14C14.5523 5 15 4.55228 15 4V2C15 1.44772 14.5523 1 14 1H7C6.44772 1 6 1.44772 6 2Z",
    stroke: "#888281",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.50024V7.50024C1 7.77639 1.22386 8.00024 1.5 8.00024H19.5C19.7761 8.00024 20 7.77639 20 7.50024V5.50024C20 5.2241 19.7761 5.00024 19.5 5.00024H1.5C1.22386 5.00024 1 5.2241 1 5.50024Z",
    stroke: "#888281",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBasket);
export default __webpack_public_path__ + "static/media/trash-basket.9be5d1a09d60befab59fb5415f42c26e.svg";
export { ForwardRef as ReactComponent };